import React, { useEffect, useState } from 'react'
import { Show, Tab, TabbedShowLayout, TopToolbar, useShowController } from 'react-admin'
import { CreateProperty } from './PropertyForm/createProperty'
import { EditProperty } from './PropertyForm/editProperty'
import ToolbarButtons from './ToolbarButtons'
import { CreateLandlord } from './LandlordForm/createLandlord'
import { EditLandlord } from './LandlordForm/editLandlord'
import ListVisits from './Visits/listVisits'
import { ShowContact } from './ContactForm/showContact'
import { makeStyles } from '@material-ui/core/styles'

const EditLeadPropertyActions = ({ data }) => {
  return (
    <TopToolbar>
      <ToolbarButtons data={data} />
    </TopToolbar>
  )
}

const useStyles = makeStyles({
  card: {
    boxShadow: 'none',
  },
})

const EditLeadProperty = (props) => {
  const { record } = useShowController(props)
  const [propertyTabDisabled, setPropertyTabDisabled] = useState(false)
  const [propertyExists, setPropertyExists] = useState(false)
  const [userExists, setUserExists] = useState(false)
  const classes = useStyles()

  useEffect(() => {
    setPropertyTabDisabled(record && !record.landlord_id)
    setPropertyExists(record && record.property_id != null)
    setUserExists(record && record.landlord_id != null)
  })

  return (
    <Show actions={<EditLeadPropertyActions {...props} />} {...props}>
      <TabbedShowLayout>
        <Tab label="Contatto" tab="lead">
          <ShowContact classes={classes} {...props} />
        </Tab>
        <Tab label="landlord" path="landlord">
          {userExists ? (
            <EditLandlord {...props} classes={classes} id={record.landlord_id} />
          ) : (
            <CreateLandlord classes={classes} {...props} />
          )}
        </Tab>
        <Tab label="property" path="property" disabled={propertyTabDisabled}>
          {propertyExists ? (
            <EditProperty {...props} classes={classes} id={record.property_id} />
          ) : (
            <CreateProperty classes={classes} {...props} />
          )}
        </Tab>
        <Tab label="inspections" path="visits" disabled={!propertyExists}>
          <ListVisits classes={classes} {...props} />
        </Tab>
      </TabbedShowLayout>
    </Show>
  )
}

export default EditLeadProperty
